import { ReligiousAndMinorityInstitutionsDto } from "../../../models/Institution/ReligiousAndMinorityInstitutionsDto";

export const determineInstitutionType = (
  institutionId: number,
  religiousAndMinorityInstitutions?: ReligiousAndMinorityInstitutionsDto
) => {
  const matchingMinoritySchool =
    religiousAndMinorityInstitutions?.minorityInstitutions?.find(
      (school) => school.id === institutionId
    );

  const matchingReligiousSchool =
    religiousAndMinorityInstitutions?.religiousInstitutions?.find(
      (school) => school.id === institutionId
    );

  return {
    isMinoritySchool: !!matchingMinoritySchool,
    isReligiousSchool: !!matchingReligiousSchool,
    schoolId: matchingMinoritySchool?.id || matchingReligiousSchool?.id || null,
  };
};
